import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Reserva } from '@app/_models/reserva';
import { ReservaDialogComponent } from '../reserva-dialog/reserva-dialog.component';
import { SessionService } from '@app/services/session.service';


const pos_initial = 1;
const pos_increment = 62;

@Component({
  selector: 'app-reserva',
  templateUrl: './reserva.component.html',
  styleUrls: ['./reserva.component.scss']
})


export class ReservaComponent implements OnInit {
  @Input() reserva: Reserva;
  @Input() startTime: number;
  @Input() endTime: number;
  @Output() reservaModified: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();

  selectedReserva: Reserva;
  desde: Date;
  hasta: Date;
  hr_initial: number = 8;
  top: number = 0;
  height: number = 60;
  type: number;

  constructor(public dialog: MatDialog, public session: SessionService) {}

  ngOnInit() {
    this.desde = new Date(this.reserva.start_time);
    this.hasta = new Date(this.reserva.end_time);
    this.type = this.reserva.reservation_type;
    this.top =
      pos_initial +
      (this.desde.getHours() + this.desde.getMinutes() * (1 / 60)) *
        pos_increment -
      this.hr_initial * pos_increment;
    let hs = this.hasta.getTime() - this.desde.getTime();
    var hoursDiff = hs / (3600 * 1000);
    this.height = hoursDiff * this.height - 15;
    
  }

  openReserva(): void {
    const config = new MatDialogConfig();
    config.data = {
      reserva: this.reserva,
    };
    config.width = '600px';
    const dialogRef = this.dialog.open(ReservaDialogComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      this.reservaModified.emit(true);
    });
  }

  getColor(id: any){
    return id == 1 ? 'partido' : id == 2 ? 'recurrente' : 'cumpleanio';
  }
}
